
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.17 4c.533 0 1.044.213 1.42.59L12 6h8a2.006 2.006 0 012 2v10a2.006 2.006 0 01-2 2H4a2.006 2.006 0 01-2-2l.01-12A2 2 0 014 4zm-2.85 6H5l3.246 5.426c.05.084.1.158.149.222a.672.672 0 00.415.252c.094.02.212.03.356.03l1.08.006c.143 0 .262-.01.355-.03a.667.667 0 00.415-.252c.05-.064.1-.138.149-.222l2.411-4.046c.045-.074.084-.133.119-.178a.409.409 0 01.107-.1.355.355 0 01.13-.044c.016-.003.097-.004.16-.005h.372c.079 0 .143.003.193.01a.378.378 0 01.13.045.413.413 0 01.107.1c.034.045.074.104.118.178l2.669 4.544H19l-3.246-5.426a2.153 2.153 0 00-.149-.223.666.666 0 00-.415-.251 1.757 1.757 0 00-.356-.03L13.754 10c-.143 0-.262.01-.355.03a.666.666 0 00-.415.252c-.05.064-.1.138-.149.222l-2.411 4.046a1.804 1.804 0 01-.119.178.344.344 0 01-.237.144 3.957 3.957 0 01-.213.005h-.32c-.078 0-.142-.003-.192-.01a.344.344 0 01-.237-.145 1.856 1.856 0 01-.118-.178L6.319 10zm7.986 2.311h-.058c0 1.616-.166 1.783-1.783 1.783v.058c1.617 0 1.783.166 1.783 1.783h.058c0-1.617.166-1.783 1.783-1.783v-.058c-1.617 0-1.783-.167-1.783-1.783z"}})])
          )
        }
      }
    